const MobileNav = {
  _selectors: {
    navTrigger: '.js-mobile-nav-trigger',
    navIcon: '.js-mobile-nav-icon',
    mobileNav: '.js-mobile-nav',
    mobileMenu: '.js-mobile-menu',
    submenuTrigger: '.js-mobile-dropdown-toggle',
    submenu: '.js-nav-menu-dropdown'
  },

  navChangeEvent: () => new CustomEvent('appeal-scroll-update'),

  init() {
    this._bindNavToggle();
    this._bindSubmenuDelegation();
  },

  _bindNavToggle() {
    const btn = document.querySelector(this._selectors.navTrigger);
    if (!btn) return;
    btn.addEventListener('click', () => this.toggleMobileNav());
  },

  _bindSubmenuDelegation() {
    const menu = document.querySelector(this._selectors.mobileMenu);
    if (!menu) return;

    menu.addEventListener('click', (e) => {
      let trigger = e.target.closest(this._selectors.submenuTrigger);

      if (e.target.nodeName == 'A') {
        trigger = e.target.parentNode;
      }

      if (!trigger || !menu.contains(trigger)) return;

      this.toggleSubmenu(trigger);``;
    });
  },

  toggleMobileNav() {
    const btn = document.querySelector(this._selectors.navTrigger);
    const nav = document.querySelector(this._selectors.mobileNav);
    const icon = document.querySelector(this._selectors.navIcon);
    const body = document.body;

    if (btn) btn.classList.toggle('hamburger--active');
    if (icon) icon.classList.toggle('hamburger--active');
    if (!nav) return;

    nav.classList.toggle('is-open');
    body.classList.toggle('no-scroll');

    document.dispatchEvent(this.navChangeEvent());
  },

  toggleSubmenu(trigger) {
    if (trigger.classList.contains('dropdown-reveal')) {
      this.closeSubmenu(trigger);
    } else {
      // only close submenus at this same level
      const parent = trigger.parentNode;
      const openSiblings = Array.from(parent.children)
        .filter(el =>
          el !== trigger && el.classList.contains('dropdown-reveal')
        );
      openSiblings.forEach(sib => this.closeSubmenu(sib));

      this.openSubmenu(trigger);
    }

    // Wait for animation to complete then dispatch event
    setTimeout(() => {
      document.dispatchEvent(this.navChangeEvent());
    }, 50);

  },

  openSubmenu(trigger) {
    const dropdown = trigger.querySelector(this._selectors.submenu);
    if (!dropdown) return;

    // start from zero so transition runs
    dropdown.style.height = '0px';
    trigger.classList.add('dropdown-reveal');

    requestAnimationFrame(() => {
      dropdown.style.height = `${dropdown.scrollHeight}px`;
    });

    dropdown.addEventListener('transitionend', () => {
      // once open, let it size naturally
      dropdown.style.height = 'auto';
    }, { once: true });
  },

  closeSubmenu(trigger) {
    const dropdown = trigger.querySelector(this._selectors.submenu);
    if (!dropdown) return;

    // force from auto -> px so transition works
    dropdown.style.height = `${dropdown.scrollHeight}px`;

    requestAnimationFrame(() => {
      dropdown.style.height = '0px';
    });

    trigger.classList.remove('dropdown-reveal');

    dropdown.addEventListener('transitionend', () => {
      // clean up inline height so re-opening works
      dropdown.style.height = '';

    }, { once: true });
  }
};

export default MobileNav;